export default "__VITE_ASSET__HaQ1mTcf__"